export var DEFAULT_PLACEHOLDER_DATE_FORMAT = 'DD / MM / YYYY';